var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmployeeLink',{attrs:{"user":_vm.user,"fallback":_vm.fallback,"name-order":_vm.nameOrder,"show-telegram-username":_vm.showTelegramUsername}})}
var staticRenderFns = []

export { render, staticRenderFns }